/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('@/bootstrap.js');
import VueMatomo from 'vue-matomo'
window.axios = require("axios");
// require("es6-promise").polyfill();
// import "core-js";
// import 'url-polyfill';
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.put["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.patch["Content-Type"] =
  "application/x-www-form-urlencoded";
require("vue-router");

import Vue from "vue";
Vue.prototype.$APPSECRET = "ChC9BxbFQaEIXo0Vt8rrgJtIIjflbpULPVH6n1kC";
Vue.prototype.$APIVERSION = "v1";
// Vue.prototype.$APIURL = location.origin + "/";
Vue.prototype.$APIURL = "https://www.amecke.de/api/";
// Vue.prototype.$APIURL = "https://amecke.test/api/";

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
  get: function () {
    return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
  }
})


/**
 * Custom Content elements, e.g. Navigation
 */
// import Navigation from "./components/Navigation";
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import router from "@/router/index.js";
import filter from "@/filter/index.js";
import header from "@/components/HeaderComponent.vue";
import footer from "@/components/FooterComponent.vue";

Vue.use(VueMatomo, { host: "https://matomo.amecke.de", siteId: 1, trackerFileName: "matomo", router: router, enableLinkTracking: !0, requireConsent: !1, trackInitialView: !0, disableCookies: !1, enableHeartBeatTimer: !0, heartBeatTimerInterval: 15, debug: !1, userId: void 0, cookieDomain: void 0, domains: void 0, preInitActions: [] });

// helpers
window.EventBus = new Vue();
window.laravueapp = new Vue({
  el: "#app",
  data: {
    menuVisible: false,
    // showFooter: true
  },
  // template: '<div><app-header/><router-view/><app-footer/></div>',

  router,
  components: {
    'app-header': header,
    'app-footer': footer,
  }
});